<template>
    <!-- start testimonial -->
    <!-- <section class="section bg-light testimonial" id="testimonial"> -->
    <section class="section testimonial" id="testimonial">
        <!-- start container -->
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-4">
                    <div class="title">
                        <p class="text-primary fw-bold mb-2">
                            Client Testimonial
                            <i class="mdi mdi-cellphone-iphone"></i>
                        </p>
                        <h3>What they think of us!</h3>
                        <p class="text-muted para-width f-15 mt-3 mb-0">
                            A Private Limited is the most popular type of
                            partnership Malta. The limited liability is, in
                            fact, the only type of company allowed by Companies.
                        </p>
                        <button class="btn bg-gradiant mt-4">
                            Read More Testimonial
                            <i class="mdi mdi-arrow-right"></i>
                        </button>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="testi-slider" id="testi-slider">
                        <div class="item">
                            <div
                                class="testi-box position-relative overflow-hidden"
                            >
                                <div class="row align-items-center">
                                    <div class="col-md-5">
                                        <img
                                            :src="
                                                require('../../../assets/landing/img/img-1.png')
                                            "
                                            alt=""
                                            class="img-fluid"
                                        />
                                    </div>
                                    <div class="col-md-7">
                                        <div class="p-4">
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <div class="flex-shrink-0">
                                                    <div class="avatar">
                                                        <img
                                                            :src="
                                                                require('../../../assets/landing/img/img-1.jpg')
                                                            "
                                                            alt=""
                                                            class="img-fluid rounded-circle"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="flex-grow-1 ms-3">
                                                    <p
                                                        class="f-14 mb-0 text-dark fw-bold"
                                                    >
                                                        <span
                                                            class="text-muted fw-normal"
                                                            >Review By
                                                        </span>
                                                        Freanki Fabel
                                                    </p>
                                                    <div class="date">
                                                        <p
                                                            class="text-muted mb-0 f-14"
                                                        >
                                                            28 jan, 2021
                                                            <span
                                                                >10:25 AM</span
                                                            >
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="mt-3">
                                                <h5>
                                                    Bulid The App That Everyone
                                                    Love.
                                                </h5>
                                                <p class="text-muted f-14">
                                                    Start working with Styza
                                                    that can provide everything
                                                    you need to generate
                                                    awareness, drive traffic,
                                                    connect.
                                                </p>
                                                <button
                                                    class="btn btn-sm bg-gradiant"
                                                >
                                                    <i
                                                        class="mdi mdi-plus f-16 align-middle"
                                                    ></i>
                                                    Follow
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="back-image position-absolute end-0 bottom-0"
                                >
                                    <img
                                        :src="
                                            require('../../../assets/landing/img/rating-image.png')
                                        "
                                        alt=""
                                        class="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- slider item -->

                        <div class="item">
                            <div
                                class="testi-box position-relative overflow-hidden"
                            >
                                <div class="row align-items-center">
                                    <div class="col-md-5">
                                        <img
                                            :src="
                                                require('../../../assets/landing/img/img-2.png')
                                            "
                                            alt=""
                                            class="img-fluid"
                                        />
                                    </div>
                                    <div class="col-md-7">
                                        <div class="p-4">
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <div class="flex-shrink-0">
                                                    <div class="avatar">
                                                        <img
                                                            :src="
                                                                require('../../../assets/landing/img/img-2.jpg')
                                                            "
                                                            alt=""
                                                            class="img-fluid rounded-circle"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="flex-grow-1 ms-3">
                                                    <p
                                                        class="f-14 mb-0 text-dark fw-bold"
                                                    >
                                                        <span
                                                            class="text-muted fw-normal"
                                                            >Review By
                                                        </span>
                                                        Freanki Fabel
                                                    </p>
                                                    <div class="date">
                                                        <p
                                                            class="text-muted mb-0 f-14"
                                                        >
                                                            28 jan, 2021
                                                            <span
                                                                >10:25 AM</span
                                                            >
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="mt-3">
                                                <h5>
                                                    Easy and prefect solution
                                                </h5>
                                                <p class="text-muted f-14">
                                                    Start working with Styza
                                                    that can provide everything
                                                    you need to generate
                                                    awareness, drive traffic,
                                                    connect.
                                                </p>
                                                <button
                                                    class="btn btn-sm bg-gradiant"
                                                >
                                                    <i
                                                        class="mdi mdi-plus f-16 align-middle"
                                                    ></i>
                                                    Follow
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="back-image position-absolute end-0 bottom-0"
                                >
                                    <img
                                        :src="
                                            require('../../../assets/landing/img/rating-image.png')
                                        "
                                        alt=""
                                        class="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>

                        <!-- slider item -->
                        <div class="item">
                            <div
                                class="testi-box position-relative overflow-hidden"
                            >
                                <div class="row align-items-center">
                                    <div class="col-md-5">
                                        <img
                                            :src="
                                                require('../../../assets/landing/img/img-3.png')
                                            "
                                            alt=""
                                            class="img-fluid"
                                        />
                                    </div>
                                    <div class="col-md-7">
                                        <div class="p-4">
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <div class="flex-shrink-0">
                                                    <div class="avatar">
                                                        <img
                                                            :src="
                                                                require('../../../assets/landing/img/img-3.jpg')
                                                            "
                                                            alt=""
                                                            class="img-fluid rounded-circle"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="flex-grow-1 ms-3">
                                                    <p
                                                        class="f-14 mb-0 text-dark fw-bold"
                                                    >
                                                        <span
                                                            class="text-muted fw-normal"
                                                            >Review By
                                                        </span>
                                                        Freanki Fabel
                                                    </p>
                                                    <div class="date">
                                                        <p
                                                            class="text-muted mb-0 f-14"
                                                        >
                                                            28 jan, 2021
                                                            <span
                                                                >10:25 AM</span
                                                            >
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="mt-3">
                                                <h5>
                                                    Bulid The App That Everyone
                                                    Love.
                                                </h5>
                                                <p class="text-muted f-14">
                                                    Start working with Styza
                                                    that can provide everything
                                                    you need to generate
                                                    awareness, drive traffic,
                                                    connect.
                                                </p>
                                                <button
                                                    class="btn btn-sm bg-gradiant"
                                                >
                                                    <i
                                                        class="mdi mdi-plus f-16 align-middle"
                                                    ></i>
                                                    Follow
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="back-image position-absolute end-0 bottom-0"
                                >
                                    <img
                                        :src="
                                            require('../../../assets/landing/img/rating-image.png')
                                        "
                                        alt=""
                                        class="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>

                        <!-- slider item -->
                        <div class="item">
                            <div
                                class="testi-box position-relative overflow-hidden"
                            >
                                <div class="row align-items-center">
                                    <div class="col-md-5">
                                        <img
                                            :src="
                                                require('../../../assets/landing/img/img-4.png')
                                            "
                                            alt=""
                                            class="img-fluid"
                                        />
                                    </div>
                                    <div class="col-md-7">
                                        <div class="p-4">
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <div class="flex-shrink-0">
                                                    <div class="avatar">
                                                        <img
                                                            :src="
                                                                require('../../../assets/landing/img/img-4.jpg')
                                                            "
                                                            alt=""
                                                            class="img-fluid rounded-circle"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="flex-grow-1 ms-3">
                                                    <p
                                                        class="f-14 mb-0 text-dark fw-bold"
                                                    >
                                                        <span
                                                            class="text-muted fw-normal"
                                                            >Review By
                                                        </span>
                                                        Freanki Fabel
                                                    </p>
                                                    <div class="date">
                                                        <p
                                                            class="text-muted mb-0 f-14"
                                                        >
                                                            28 jan, 2021
                                                            <span
                                                                >10:25 AM</span
                                                            >
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="mt-3">
                                                <h5>
                                                    Bulid The App That Everyone
                                                    Love.
                                                </h5>
                                                <p class="text-muted f-14">
                                                    Start working with Styza
                                                    that can provide everything
                                                    you need to generate
                                                    awareness, drive traffic,
                                                    connect.
                                                </p>
                                                <button
                                                    class="btn btn-sm bg-gradiant"
                                                >
                                                    <i
                                                        class="mdi mdi-plus f-16 align-middle"
                                                    ></i>
                                                    Follow
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="back-image position-absolute end-0 bottom-0"
                                >
                                    <img
                                        :src="
                                            require('../../../assets/landing/img/rating-image.png')
                                        "
                                        alt=""
                                        class="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- slider item -->
                    </div>
                </div>
            </div>
        </div>
        <!-- end container -->
    </section>
    <!-- end testimonial -->
</template>
<script>
import { tns } from "tiny-slider";
export default {
    mounted() {
        tns({
            container: ".testi-slider",
            loop: true,
            autoplay: false,
            mouseDrag: true,
            controls: false,
            navPosition: "bottom",
            nav: true,
            autoplayTimeout: 5000,
            speed: 900,
            center: false,
            animateIn: "fadeIn",
            animateOut: "fadeOut",
            controlsText: ["&#8592;", "&#8594;"],
            autoplayButtonOutput: false,
            gutter: 30,
            responsive: {
                992: {
                    gutter: 30,
                    items: 1.2,
                },
            },
        });
    },
};
</script>
